type AppEnv = "localhost" | "development" | "qa" | "uat" | "staging" | "production";

const ENV_SEGMENT: Record<AppEnv, string> = {
  localhost: "localhost",
  development: "dev",
  qa: "qa",
  uat: "uat",
  staging: "staging",
  production: "",
};

export const buildEntityWorkspaceUrl = (subDomain: string): string => {
  const env = import.meta.env.VITE_APP_ENV as AppEnv;
  const segment = ENV_SEGMENT[env];
  return segment !== undefined && segment !== ""
    ? `https://${subDomain}.${segment}.servengine.com`
    : `https://${subDomain}.servengine.com`;
};
